// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_HELP_LINK = "Op\u00fdtaj sa n\u00e1s";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const WIKI_ARTICLE_ADD_NEW = "Pridaj nov\u00fd \u010dl\u00e1nok";
export const WIKI_ARTICLE_EDIT = "Uprav";
